var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('kst-section',{attrs:{"confirm-mode":""}},[_c('kst-warning',{staticClass:"mb-4",attrs:{"items":_vm.detailsWarning}}),_c('kst-input',{attrs:{"field":"PONumberConfirm","data":_vm.userData,"catalog":_vm.Catalog,"customValidations":_vm.PONumberValidations}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }